<block-ui>
    <ul class="nav nav-tabs" id="comprasTab" role="tablist">
        <li class="nav-item">
            <button class="nav-link active" id="solicitud-tab" data-toggle="tab" role="tab" aria-controls="solicitud"
                aria-selected="true" (click)="SwitchTab(CONFIG_TYPE.PurchaseRequest)">Solicitud de Compra</button>
        </li>
        <li class="nav-item">
            <button class="nav-link" id="orden-tab" data-toggle="tab" role="tab" aria-controls="orden"
                aria-selected="false" (click)="SwitchTab(CONFIG_TYPE.PurchaseOrder)">Orden de Compra</button>
        </li>
    </ul>
    <div class="tab-content mb-2" id="comprasTabContent">
        <div class="d-flex flex-row-reverse mt-4">
            <div class="form-group">
                <button type="button"
                    class="form-control form-control-sm btn-light shadow-sm btn-st float-right"
                    (click)="SaveConfiguration()">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    Guardar
                </button>
            </div>
        </div>
        <div class="row mt-0">
            <form class="col" [formGroup]="configuracionForm">
                <div class="row">
                    <input hidden type="number" aria-describedby="identificador" formControlName="Id">
                    <input hidden type="text" aria-describedby="tipo" formControlName="Type">
                    <input hidden type="checkbox" aria-describedby="estado" formControlName="IsActive">
                    <div class="form-group col" style="display: none;">
                        <label for="correo">Cuenta de correo</label>
                        <select type="email" class="form-control form-control-sm" id="correo" aria-describedby="correo"
                            formControlName="Email" disabled>
                            <option value="claviscoweb@clavisco.com">claviscoweb@clavisco.com</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col">
                        <label for="correos">Correos</label>
                        <input id="correos" aria-describedby="correos" formControlName="Emails" type="text"
                            class="form-control form-control-sm" (keyup)="AddEmail($event)"
                            (focusout)="AddEmailFocusOut($event)"
                            [ngClass]="{'is-invalid': configuracionForm.controls.Emails.invalid}">
                        <div class="mt-2">
                            <span class="badge bag-correo ml-1 text-white" *ngFor="let mail of mails; index as i">
                                {{mail}} 
                                <span class="badge badge-light" (click)="DeleteMail(i)" style="cursor: pointer">
                                    <i class="fa fa-times"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                    <div class="form-group col">
                        <label for="copycorreos">Correos copia</label>
                        <input id="copycorreos" aria-describedby="copycorreos" formControlName="CopyEmails" type="text"
                            class="form-control form-control-sm" (keyup.enter)="AddCopyEmail($event)"
                            (focusout)="AddCopyEmailFocusOut($event)"
                            [ngClass]="{'is-invalid': configuracionForm.controls.CopyEmails.invalid}">
                        <div class="mt-2">
                            <span class="badge bag-correo ml-1 text-white " *ngFor="let mail of copymails; index as i">
                                {{mail}} 
                                <span class="badge badge-light" (click)="DeleteCopyMail(i)" style="cursor: pointer">
                                    <i class="fa fa-times"></i>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="form-group col-sm-4">
                            <label for="asunto">Asunto del mensaje</label>
                            <input type="text" class="form-control form-control-sm" id="asunto"
                                aria-describedby="asunto" formControlName="Subject">
                    </div>
                    <div class="form-group col-sm-4">
                        <label for="frecuencia">Frecuencia ejecución</label>
                        <div class="input-group input-group-sm">
                            <input type="number" class="form-control form-control-sm" id="frecuencia"
                                aria-describedby="frecuencia" formControlName="TimeRep">
                            <div class="input-group-append">
                                <span class="input-group-text" id="minutos">minutos</span>
                            </div>
                        </div>
                    </div>
                    <div class="form-group col-sm-4">
                        <div  *ngIf="this.configTYPE == 'OPOR'" class="form-group">
                            <label>&nbsp;</label>
                            <a class="btn form-control form-control-sm btn-sm" style="background-color:#2e3952; color:white"
                                (click)="openModal(content)">
                                 Formatos de Impresión </a>
                        </div>
                        <div *ngIf="this.configTYPE == 'OPRQ'" class="form-group">
                        <label for="file">Formatos de impresión</label>
                        <div class="d-flex flex-row">
                            <button type="button" class="boton-standar-rw form-control form-control-sm btn-light shadow-sm btn-st float-right" 
                            (click)="file.click()" title="Cargar nuevo reporte">{{(CrystalReportName)?CrystalReportName:"Seleccione un reporte..."}}</button>
                            <input #file (change)="FileBrowseHandler($event)" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" 
                                type="file" name="" id="file" placeholder="file" style="display: none !important">
                            <div>
                                <button type="button" class="form-control form-control-sm btn-light shadow-sm btn-st float-right" (click)="fn_downloadFile(CrystalReportName)" title="Descargar Reporte">
                                    <i class="fa fa-download" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label for="cuerpo">Cuerpo del mensaje</label>
                    <textarea class="form-control form-control-sm" id="cuerpo" rows="6" aria-describedby="cuerpo"
                        formControlName="Body"></textarea>
                </div>
            </form>
        </div>
    </div>
    <!--Modal config formatos de impresión -->
    <ng-template #content let-modal>
        <div class="modal-header">
            <h6 class="modal-title">Formatos de impresión </h6>
            <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
        </div>
        <div class="modal-body-scrollable tableFixHead">
            <table class="table">
                <thead>
                    <tr style="position: sticky; top:0; z-index: 1;">                       
                        <th scope="col"><h6>Descripción</h6></th>
                        <th></th>                      
                          
                    </tr>
                </thead>
                <tbody data-spy="scroll">
                    <tr *ngFor="let imp of udfFormatoValues; index as i" >
                        <!-- <th scope="row">{{ i + 1 }}</th>  -->
                                             
                        <td >{{ imp.IdUdf }} - {{ imp.Description }}</td>
                        <td>
                            <div class="d-flex flex-row">
                                <button type="button" 
                                      class="boton-standar-rw form-control form-control-sm btn-light shadow-sm btn-st float-right" 
                                      (click)="file.click()" title="Cargar nuevo reporte">{{(imp.ReportName)?imp.ReportName:"Seleccione un reporte..."}}
                                </button>
                                <input #file (change)="FileBrowseHandler($event,imp.IdUdf)" 
                                      class="form-control form-control-sm btn-light shadow-sm btn-st float-right" 
                                      type="file" 
                                      name="" id="file" placeholder="file" 
                                      style="display: none !important">
                                <div>
                                    <button type="button" 
                                        class="form-control form-control-sm btn-light shadow-sm btn-st float-right" 
                                        (click)="fn_downloadFile(imp.ReportName)"title="Descargar Reporte">
                                        <i class="fa fa-download" aria-hidden="true"></i>
                                    </button>
                                </div>
                          </div>
                      </td>
                     
                        
                      </tr>
                </tbody>
            </table>
        </div>
        <div class="modal-footer">
            <button type="button" style="border:solid 1px gainsboro;"
                    class="btn btn-sm shadow-sm btn-light"
                    (click)="SaveFormato()">
                    <i class="fa fa-floppy-o" aria-hidden="true"></i>
                    Guardar Formato
                </button>
            
            <button type="button"  style="border:solid 1px gainsboro;" class="btn btn-sm shadow-sm btn-light" (click)="close()"> <i class="fa fa-ban" aria-hidden="true"></i>&nbsp;Cancelar</button>
        </div>
    </ng-template>
    <!--Fin Modal config formatos de impresión-->
</block-ui>